export default "<p>check-before-redirect works!</p>\n"